import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/content';
export function FitSection() {
  return <section className="bg-night" data-id="element-77" data-mp="1an1pc35a7nsq">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-20" data-id="element-78" data-mp="1p9uu4eh6db6o">
        <h2 className="text-center font-display text-3xl font-semibold tracking-tight text-parchment sm:text-4xl" data-id="element-79" data-mp="1pbfs6e2p7c9a">
          ¿Es para vos?
        </h2>

        <div className="mx-auto mt-10 grid max-w-4xl gap-6 md:grid-cols-2" data-id="element-80" data-mp="1ya032t20ohmy">
          <div className="rounded-2xl border border-gold-soft/40 bg-night-panel p-7" data-id="element-81" data-mp="1tbyk084lcibh">
            <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-82" data-mp="1te2oosabdlct">
              ✅ Sí, es para vos si
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-83" data-mp="23b78ilgot4qg">
              {forYou.map(item => <li key={item} className="flex gap-3" data-id="element-84" data-mp="dvzez5q9t2fg">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold-soft" aria-hidden="true" data-id="element-85" data-mp="dwsmwa0ytxz6" />
                  <span className="font-sans text-base text-parchment/85" data-id="element-86" data-mp="2jtk1t7bxgu4a">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-night-line bg-night-panel/60 p-7" data-id="element-87" data-mp="2st703k9d1jt4">
            <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.14em] text-rust-soft" data-id="element-88" data-mp="2xjngnd8h9ljp">
              ✕ No es para vos si
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-89" data-mp="32i8ghbjti37m">
              {notForYou.map(item => <li key={item} className="flex gap-3" data-id="element-90" data-mp="37gs0h6eup4xc">
                  <XIcon className="mt-0.5 h-5 w-5 flex-none text-rust-soft" aria-hidden="true" data-id="element-91" data-mp="3bjey5ny7dk2g" />
                  <span className="font-sans text-base text-parchment/60" data-id="element-92" data-mp="3ghzpsyze2vfa">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}